jQuery(document).ready(function($){
    $('.mobile-prod').slick({
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true
    });
    $('.mob-slick').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        responsive: [
            {
                breakpoint: 769,
                settings: 'unslick'
            }
        ]
    });
    $('.product-feed-wrapper .product-row').slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        dots: true,
        responsive: [
            {
                breakpoint: 769,
                settings: 'unslick'
            }
        ]
    });
});